import { Row } from 'react-bootstrap';
import styled from 'styled-components';

export const BodyModalConnectionWrapper = styled(Row)`
  margin-bottom: 30px;
`;
